import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Select,
  Spin,
  message,
  Card,
  Checkbox,
  Collapse,
  Icon,
  Upload,
  notification,
} from "antd";
import Trash from "../../Images/trash.png";
import { Storage } from "aws-amplify";
import { DatePicker } from "antd";
import { TimePicker } from "antd";
import moment from "moment";
import AppConfigs from "../../Config/AppConfig";
import { list, update, add, deleteRecord } from "../../api/Apis";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import NumberFormat from "react-number-format";
import { CameraOutlined } from "@ant-design/icons";
import Docsample from "../../Images/pdf.jpg";
import "./OrderDetails.css";

const { Option } = Select;
const format = "hh:mm A";
const { Panel } = Collapse;
const { TextArea } = Input;
function beforeUpload(file) {
  // const isJpgOrPng =
  //   file.type === "image/jpeg" ||
  //   file.type === "image/png" ||
  //   file.type === "application/pdf";
  // if (!isJpgOrPng) {
  //   notification["error"]({
  //     message: "You can only upload JPG/PNG file!",
  //   });
  // }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    notification["error"]({
      message: "Image must smaller than 2MB!",
    });
  }
  // return isJpgOrPng && isLt2M;
  return isLt2M;
}

class Finishorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      cartLoading: false,
      subtotal: 0,
      delivery: 0,
      cartData: [],
      locations: [],
      startOpen: false,
      endOpen: false,
      startValue: "",
      endValue: "",
      imageUrl: [],
      expandIconPosition: "right",
      open: "0",
      sameAddressForAll: false,
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      confirmDeliveryOption: false,
    };
  }

  handleUploadPic = async (fileData, imageType, poNumber, index) => {
    if (fileData.event) {
      this.setState({
        loading: true,
      });

      let file = fileData["file"]["originFileObj"];
      let fileName = poNumber + imageType + file["name"];
      await Storage.put(fileName, file, {
        contentType: file.type,
      }).then(async (result) => {
        let imageUrlarray = this.state.imageUrl;
        imageUrlarray[index - 1] = result.key;
        this.setState({
          imageUrl: imageUrlarray,
          loading: false,
        });
      });
    }
  };

  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);

  onChange1(event, index) {
    this.setState({ orderFields: event.target.value });
  }

  handleConfirmDelivery = () => {
    this.setState((prevState) => ({
      confirmDeliveryOption: !prevState.confirmDeliveryOption,
    }));
  };
  

  onChange = (checkedValues) => {
    console.log("checked = ", checkedValues);
  };
  callback(key) {
    console.log(key);
  }
  componentDidMount = () => {
    const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let locations = [];
    orgDetails["customerLocations"] &&
      orgDetails["customerLocations"].map((location, index) => {
        let address = location["location"]; // + "," + location["address"] + "," + location["city"] + "," + location["state"] + "," + location["pincode"];
        return locations.push(address);
      });
    this.setState({
      locations: locations,
      loading: false,
    });
  };

  getCartData = async () => {
    list(AppConfigs["getCartData"] + "/" + this.state.orgDetails.id, {}).then(
      async (result) => {
        if (result.success) {
          let cartData = result.data;
          if (cartData.length === 0) {
            this.props.context.setCartData(cartData);
            localStorage.setItem("cartData", JSON.stringify(cartData));
            this.props.history.push("/app/stones");
          } else {
            cartData.map(async (item) => {
              item["image"] = await Storage.get(item["image"]);
              this.setState({
                cartData: [...this.state.cartData, item],
              });
              this.props.context.setCartData(cartData);
              localStorage.setItem("cartData", JSON.stringify(cartData));
            });
            this.setState({
              loading: false,
            });
          }
        } else {
          console.log(result.errors);
          this.setState({
            loading: false,
          });
        }
      }
    );
  };

  changeMeasurementType = async (measurementType, itemId, quantity) => {
    if (measurementType === "Truckload" && parseInt(quantity) > 1) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    }
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        measurementType: measurementType,
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };

  changeTruckType = async (deliveryTruck, itemId) => {
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        deliveryTruck: deliveryTruck,
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        let cartData = this.props.context.state.cartData;
        let totalAmt = 0,
          totalQuantity = 0;
        if (cartData[0]["totalAmt"] === 0) {
          message.error(
            "This product is currently not available by the " +
              cartData[0]["measurementType"] +
              ""
          );
          this.setState({
            loading: false,
          });
          return;
        }
        cartData.map(async (item) => {
          totalAmt += item["totalAmt"] ? parseFloat(item["totalAmt"]) : 0;
          totalQuantity +=
            item["quantity"] && item.itemType === "Pallet"
              ? item["quantity"] * 1.5
              : item["quantity"];
        });
        const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        let cartIds = cartData.map((item) => {
          return item["id"];
        });
        let selectedCustomerLocation = [],
          cartItems = [];
        cartData.map((cart, index) => {
          console.log(values[cart["id"] + "_location"]);
          selectedCustomerLocation = orgDetails.customerLocations.filter(
            (location) => location.location === values[cart["id"] + "_location"]
          );
          cartItems.push({
            id: cart["id"],
            deliveryTruck: cart["deliveryTruck"],
            measurementType: cart["measurementType"],
            productId: cart["productId"],
            productName: cart["productName"],
            productOrigin: cart["productOrigin"],
            quantity: parseInt(cart["quantity"]),
            size: cart["size"],
            totalAmt: cart["totalAmt"],
            amount: cart["amount"],
            poNumber: values[cart["id"] + "_poNumber"],
            orderDocument: this.state.imageUrl[index],
            locationName: values[cart["id"] + "_location"],
            address: selectedCustomerLocation?.[0]?.["address"],
            notes: values[cart["id"] + "_notes"],
            deliveryReqDate: moment(
              values[cart["id"] + "_deliveryDate"]
            ).format("MM/DD/YYYY"),
            deliveryReqTime:
              moment(values[cart["id"] + "_deliveryStartTime"]).format(
                "hh:mm A"
              ) +
              " - " +
              moment(values[cart["id"] + "_deliveryEndTime"]).format("hh:mm A"),
            image: cart["originalPath"],
          });
          return cart;
        });
        let data = {
          orderData: {
            customerEmail: userDetails["email"],
            customerName:
              userDetails["firstName"] + " " + userDetails["lastName"],
            companyName: orgDetails["companyName"],
            customerProfile: userDetails["userProfile"],
            customerSubUserOf: userDetails["orgId"],
            pincode: null, //values["pincode"],
            notes: null,
            subtotal: totalAmt,
            deliveryAmt: 0,
            totalAmt: totalAmt,
            quantity: totalQuantity,
            orderStatus: AppConfigs["NEW"],
            pushToCarrier: false,
            assignCarrier: false,
            cartItems: cartItems,
            customerId: orgDetails["id"],
            isPalletOrder: cartData[0]["itemType"] !== "bulk" ? true : false,
            customerLatLng:
              selectedCustomerLocation[0] &&
              "latLng" in selectedCustomerLocation[0]
                ? selectedCustomerLocation[0]["latLng"]
                : null,
            rateValue: null,
            callForRate: false,
            orgId: orgDetails["orgId"],
          },
          cartData: cartIds,
        };
        if (data["orderData"]["quantity"] > 24) {
          notification["error"]({
            message:
              "An order can have a max of 24 tons. Please remove some items from the cart to proceed.",
          });
          this.setState({
            loading: false,
          });
          // eslint-disable-next-line array-callback-return
          return;
        }

        add(AppConfigs["addOrder"], data).then((result) => {
          if (result.success) {
            // localStorage.setItem("orgDetails", JSON.stringify(result.data.data));
            message.success("Order placed successfully");
            localStorage.removeItem("cartData");
            this.props.context.setCartData([]);
            window.location =
              "/app/orderconfirm/" + result["data"]["data"]["id"];
          } else {
            message.error(result.errors.message.message);
            this.setState({
              loading: false,
            });
          }
        });
      } else {
        message.error(err[Object.keys(err)[0]].errors[0].message);
      }
    });
  };
  datefield = (date, dateString) => {
    // console.log(date, dateString);
  };
  timefield = (time, timeString) => {
    // console.log(time, timeString);
  };
  timefieldEnd = (time, timeString) => {
    // console.log(time, timeString);
  };

  setStartValue = (value, index, id) => {
    this.setState({
      startValue: value,
    });
    this.changeFieldValue(value, index, id);
  };
  setEndValue = (value, index, id, recordId) => {
    if (!value) {
      if (
        this.props.form.getFieldValue(recordId + "_deliveryStartTime") >
        this.props.form.getFieldValue(recordId + "_deliveryEndTime")
      ) {
        message.error("Please select valid time");
        this.props.form.setFieldsValue({
          [recordId + id]: null,
        });
        return;
      } else {
        this.props.form.setFieldsValue({
          [recordId + id]: this.props.form.getFieldValue(
            recordId + "_deliveryEndTime"
          ),
        });
      }
      this.changeFieldValue(value, index, id, recordId);
    }
  };
  // getStartDisabledHours = () => {
  //   const minHour = -1;
  //   const maxHour = this.state.endValue ? this.state.endValue.hours() : 24;
  //   return Array.from({ length: 24 }, (v, k) => k).filter(
  //     hour => hour < minHour || hour > maxHour
  //   );
  // }
  // getStartDisabledMinutes = (startSelectedHour) => {
  //   const minMinutes = -1;
  //   const maxMinutes =
  //     this.state.endValue && startSelectedHour >= this.state.endValue.hours()
  //       ? this.state.endValue.minutes()
  //       : 60;

  //   return Array.from({ length: 60 }, (v, k) => k).filter(
  //     minutes => minutes < minMinutes || minutes > maxMinutes
  //   );
  // }
  // getEndDisabledHours = () => {
  //   const minHour = this.state.startValue ? this.state.startValue.hours() : -1;
  //   const maxHour = 24;
  //   return Array.from({ length: 24 }, (v, k) => k).filter(
  //     hour => hour < minHour || hour > maxHour
  //   );
  // }
  // getEndDisabledMinutes = (endSelectedHour) => {
  //   const minMinutes =
  //     this.state.startValue && endSelectedHour <= this.state.startValue.hours()
  //       ? this.state.startValue.minutes()
  //       : -1;
  //   const maxMinutes = 60;
  //   return Array.from({ length: 60 }, (v, k) => k).filter(
  //     minutes => minutes < minMinutes || minutes > maxMinutes
  //   );
  // }
  addToCart = (item) => {
    // let tonValue =
    //   this.state.stoneWeight !== ""
    //     ? this.state.stoneWeight
    //     : this.state.stoneData[0]["pallet"] !;

    // let palletValue = this.state.stoneData.filter(
    //   (p) => p.ton === tonValue && p
    // );
    // if (palletValue[0].pallet === "0") {
    //   message.error("This product is currently not available by the pallet");
    //   return;
    // } else
    if (item.measurementType === "") {
      // alert("Please select measurement");
      message.error("Please select measurement");
      return;
    } else if (item.count === 0) {
      // alert("Please select quantity");
      message.error("Please select quantity");
      return;
    } else if (
      item.deliveryTruck === "" &&
      item.measurementType === "Truckload"
    ) {
      // alert("Please select quantity");
      message.error("Please select Delivery Truck");
      return;
    }
    // else if (
    //   item.measurementType === "Truckload" &&
    //   item.stoneData[0]["truckload"] === "0"
    // ) {
    //   // alert("Please select quantity");
    //   message.error("This product is currently not available by the truckload");
    //   return;
    // }
    //  else if (this.state.stoneData[0]["ton"] === "0") {
    //   // alert("Please select quantity");
    //   message.error("This product is currently not available by the ton");
    //   return;
    // }

    if (item.measurementType === "Truckload" && item.count > 1) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    }
    // if (location === "Milford") {
    //   this.setState({
    //     addToCartMilfordLoading: true,
    //   });
    // } else {
    this.setState({
      addToCartLoading: true,
    });
    // }
    let data = {
      entityData: {
        productId: item.productId,
        size: item.size,
        // ton:
        //   item.stoneWeight !== ""
        //     ? item.stoneWeight
        //     : item.stoneData[0]["pallet"] !== "0"
        //     ? item.stoneData[0]["ton"]
        //     : item.stoneData[1]["ton"],
        locationName: this.props.form.getFieldValue(item["id"] + "_location"),
        productLinkId: item.productId,
        measurementType: item.measurementType,
        deliveryTruck: item.deliveryTruck !== "" ? item.deliveryTruck : null,
        quantity: item.quantity,
        customerId: this.state.orgDetails["id"],
        orgId: this.state.orgDetails["orgId"],
      },
    };
    let existingCartData = JSON.parse(localStorage.getItem("cartData"));
    if (
      existingCartData &&
      existingCartData[0] &&
      existingCartData[0].deliveryTruck &&
      existingCartData[0].deliveryTruck !== item.deliveryTruck &&
      existingCartData[0].measurementType !== "Pallet"
    ) {
      if (
        (item.measurementType === "Pallet" &&
          existingCartData[0].measurementType !== "Pallet") ||
        (item.measurementType === "Truckload" &&
          existingCartData[0].measurementType === "Pallet")
      ) {
        notification["error"]({
          message: `You can only order bulk gravel or pallets in a single order. Please create separate orders for each`,
        });
        this.setState({
          addToCartLoading: false,
          addToCartMilfordLoading: false,
        });
        return;
      }
      // notification["error"]({
      //   message: `Your cart has a ${
      //     existingCartData[0].measurementType === "Pallet"
      //       ? "Pallet"
      //       : existingCartData[0].deliveryTruck
      //   } ordered with a different truck type.${
      //     existingCartData[0].measurementType === "Pallet"
      //       ? " Please select only one truck type for up to 24 pallets in each order. Thank you"
      //       : "Please select only one truck type in each order. Thank you"
      //   } .`,
      // });
      this.setState({
        addToCartLoading: false,
        addToCartMilfordLoading: false,
      });
      // return;
    }

    // const { stoneWeight, stoneData } = item;
    let total_weight = 0;
    if (existingCartData != null) {
      existingCartData.map((d) => (total_weight = total_weight + d.weight));
    }
    let check_total_weight;
    // let ton = 0;
    // existingCartData.map((d) => (ton = ton + d.ton));
    // let totalQuantity = ton + stoneWeight ? stoneWeight : stoneData[0]["ton"];

    // if (ton > 24 || stoneWeight > 24 || totalQuantity > 24) {
    // if (quantity > 24 || item.count > 24 || totalQuantity > 24) {
    //   notification["error"]({
    //     message:
    //       "You can only order up to 24 pallets per truck in a single order. If you wish to order more than 24 pallets, please create a new order with the additional pallets. Thank you.",
    //   });
    //   this.setState({
    //     addToCartLoading: false,
    //   });
    //   return;
    // }
    // if (
    //   existingCartData &&
    //   existingCartData[0] &&
    //   existingCartData[0].measurementType === "Truckload"
    //   // quantity < 2
    // ) {
    //   notification["error"]({
    //     message: "You can only place one truckload per order",
    //   });
    //   this.setState({
    //     addToCartLoading: false,
    //     addToCartMilfordLoading: false,
    //   });
    //   return;
    // }
    if (item.measurementType !== "Truckload") {
      let numOfTons;
      let checkProduct =
        existingCartData !== null &&
        existingCartData.filter(
          (c) =>
            c.productId === this.props.match.params.id &&
            item.measurementType === c.measurementType &&
            item.size === c.size
        );
      if (checkProduct.length > 0) {
        data["entityData"]["quantity"] =
          parseInt(checkProduct[0]["quantity"]) + parseInt(item.count);
        data["entityData"]["id"] = checkProduct[0]["id"];
        let totalTon =
          parseFloat(data["entityData"]["ton"].split(" Ton")[0]) *
          parseInt(item.count);
        numOfTons =
          parseFloat(checkProduct[0]["weight"]) + parseFloat(totalTon);
        // data["entityData"]["wieght"] = numOfTons;
      } else {
        let totalTon = data["entityData"]["ton"].split(" Ton");
        numOfTons = parseFloat(totalTon[0]) * data["entityData"]["quantity"];
        // data["entityData"]["wieght"] = numOfTons;
      }
      check_total_weight = total_weight + item.count;
      data["entityData"]["wieght"] = numOfTons;

      // data["entityData"]["ton"] =
      //   item.stoneWeight !== ""
      //     ? item.stoneWeight
      //     : item.stoneData.length > 0 && item.stoneData[0]?.ton;
    }
    // if (data["entityData"]["wieght"] > 24 || check_total_weight > 24) {
    //   notification["error"]({
    //     message:
    //       "An order can have a max of 24 tons. Please remove some items from the cart to proceed.",
    //   });
    //   this.setState({
    //     addToCartLoading: false,
    //     addToCartMilfordLoading: false,
    //   });
    //   return;
    // }
    add(AppConfigs["addItemToCart"], data).then((result) => {
      if (result.success) {
        let cartData = result.data.data;
        cartData &&
          cartData.map(async (item, index) => {
            item["originalPath"] = item["image"];
            item["image"] = await Storage.get(item["image"]);
            if (cartData.length === index + 1) {
              this.props.context.setCartData(cartData);
              localStorage.setItem("cartData", JSON.stringify(cartData));
              message.success("Product added to cart");
            }
          });
      } else {
        message.error(`Product not added to cart`);
        console.log(result.errors);
      }
      this.setState({
        addToCartLoading: false,
        deliveryTruck: "",
      });
      // window.location.reload();
    });
  };

  quantityIncrement = (item, measurementType, quantity, itemId) => {
    if (measurementType === "Truckload" && parseInt(quantity) + 1 > 1) {
      // message.error("Only 1 truckload can be ordered at a time.");
      this.addToCart(item);
      return;
    }
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        quantity: quantity + 1,
        totalAmt: (item.totalAmt / quantity) * (quantity + 1),
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };
  quantityDecrement = (item, quantity, itemId) => {
    this.setState({
      loading: true,
    });
    let data = {
      entityData: {
        quantity: quantity - 1,
        totalAmt: (item.totalAmt / quantity) * (quantity - 1),
      },
    };
    update(AppConfigs["entityNames"]["cart"], itemId, data).then((result) => {
      if (result.success) {
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });
  };
  deleteCartItem = async (itemId) => {
    this.setState({
      loading: true,
    });

    deleteRecord(AppConfigs["entityNames"]["cart"], itemId).then((result) => {
      if (result.success) {
        message.success("Product deleted successfully");
        localStorage.removeItem("cartData");
        this.getCartData();
      } else {
        console.log(result.errors);
      }
    });

    this.setState({
      loading: false,
    });
  };

  selectAddress = (e) => {
    this.setState({
      sameAddressForAll: e.target.checked,
    });
    if (e.target.checked && this.props.context.state.cartData.length > 1) {
      this.props.context.state.cartData.map(async (cart, index) => {
        if (index > 0) {
          await this.props.form.setFieldsValue({
            [cart["id"] + "_poNumber"]: this.props.form.getFieldValue(
              this.props.context.state.cartData[0]["id"] + "_poNumber"
            ),
            [cart["id"] + "_location"]: this.props.form.getFieldValue(
              this.props.context.state.cartData[0]["id"] + "_location"
            ),
            [cart["id"] + "_notes"]: this.props.form.getFieldValue(
              this.props.context.state.cartData[0]["id"] + "_notes"
            ),
            [cart["id"] + "_deliveryDate"]: this.props.form.getFieldValue(
              this.props.context.state.cartData[0]["id"] + "_deliveryDate"
            ),
            [cart["id"] + "_deliveryStartTime"]: this.props.form.getFieldValue(
              this.props.context.state.cartData[0]["id"] + "_deliveryStartTime"
            ),
            [cart["id"] + "_deliveryEndTime"]: this.props.form.getFieldValue(
              this.props.context.state.cartData[0]["id"] + "_deliveryEndTime"
            ),
            // [cart["id"]+"_deliverBy"] : this.props.form.getFieldValue(this.props.context.state.cartData[0]['id']+"_deliverBy")
          });
        }
      });
    }
  };

  changeFieldValue = (value, index, id, recordId) => {
    if (
      this.props.context.state.cartData.length > 1 &&
      this.state.sameAddressForAll &&
      index === 0
    ) {
      this.props.context.state.cartData.map(async (cart) => {
        await this.props.form.setFieldsValue({
          [cart["id"] + id]: value,
          [cart["id"] + "_deliveryEndTime"]: this.props.form.getFieldValue(
            recordId + "_deliveryEndTime"
          ),
        });
      });
    }
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    let cartData = this.props.context.state.cartData;
    let subtotal = 0;
    let loading = true;
    cartData.map(async (item, index) => {
      subtotal += parseFloat(item["totalAmt"] !== null ? item["totalAmt"] : 0);
      if (index === cartData.length - 1) {
        loading = false;
      }
    });
    return (
      <div>
        <Spin spinning={this.state.loading}>
          <Spin spinning={loading}>
            <Row>
              <Form onSubmit={this.handleSubmit}>
                <Col
                  lg={17}
                  md={17}
                  sm={24}
                  xs={24}
                  style={{ padding: "50px" }}
                >
                  <h2 className="quoteheading">
                    {/* To finish ordering process, please, add next <br /> details for each of the items. */}
                    To complete this order please add more details for each of
                    the items.
                  </h2>
                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ marginTop: "2%", marginLeft: "15px" }}
                  >
                    <Checkbox
                      value="details"
                      className="custom_checkbox"
                      onChange={this.selectAddress}
                    >
                      Delivery location details are the same for each below item
                    </Checkbox>
                  </Col>
                  {window.innerWidth >= 768 && (
                    <Row gutter={8} style={{ marginTop: "8%" }}>
                      <Col lg={1} md={1} ms={24} xs={24} />
                      <Col lg={1} md={1} ms={24} xs={24}>
                        <p style={{ textAlign: "center" }}>#</p>
                      </Col>
                      <Col lg={7} md={7} sm={24} xs={24}>
                        <p style={{ textAlign: "center" }}>Product</p>
                      </Col>
                      <Col lg={6} md={6} sm={24} xs={24}>
                        <p style={{ marginLeft: "40px" }}>Quantity</p>
                      </Col>
                      <Col lg={5} md={5} sm={24} xs={24}>
                        <p>Type of Delivery Truck</p>
                      </Col>
                      <Col lg={2} md={2} sm={24} xs={24}>
                        <p>Price Per Ton</p>
                      </Col>
                    </Row>
                  )}
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div>
                      {cartData.map((item, index) => {
                        if (item.measurementType === "Pallet") {
                          return (
                            <Collapse
                              key={item["id"]}
                              defaultActiveKey={["1"]}
                              expandIconPosition={this.state.expandIconPosition}
                              expandIcon={({ isActive }) =>
                                index === 0 && (
                                  <Icon
                                    type="caret-down"
                                    rotate={isActive ? 180 : 0}
                                  />
                                )
                              }
                              onChange={this.callback}
                              className="custom_collapse"
                              style={{ marginTop: "2%", borderRadius: "10px" }}
                            >
                              <Panel
                                header={
                                  <div>
                                    <Row gutter={8}>
                                      <Col
                                        lg={1}
                                        md={1}
                                        sm={24}
                                        xs={24}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <Checkbox.Group
                                          defaultValue={["order"]}
                                          style={{ width: "100%" }}
                                          onChange={this.onChange}
                                        >
                                          <Checkbox
                                            value="order"
                                            className="custom_checkbox"
                                          />
                                        </Checkbox.Group>
                                      </Col>
                                      <div
                                        onClick={(event) =>
                                          event.stopPropagation()
                                        }
                                      >
                                        <Col
                                          lg={1}
                                          md={1}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <p>1</p>
                                        </Col>
                                        <Col lg={7} md={7} sm={24} xs={24}>
                                          <img
                                            style={{
                                              width: "70px",
                                              height: "60px",
                                              borderRadius: "5px",
                                            }}
                                            src={item["image"]}
                                            alt="img"
                                          />
                                          <span style={{ marginLeft: "10px" }}>
                                            <b>
                                              {item["productName"] +
                                                " - " +
                                                item["size"]}
                                            </b>
                                          </span>
                                        </Col>
                                        <Col
                                          lg={6}
                                          md={6}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          {/* <span className="count" style={{ textDecoration: 'underline' }}>{item["quantity"]}</span> */}
                                          <div>
                                            {item["quantity"] <= 1 ? (
                                              <Button
                                                disabled
                                                className="quantitybtn"
                                                onClick={() => {
                                                  this.quantityDecrement(
                                                    item,
                                                    item["quantity"],
                                                    item["id"]
                                                  );
                                                }}
                                              >
                                                -
                                              </Button>
                                            ) : (
                                              <Button
                                                className="quantitybtn"
                                                onClick={() => {
                                                  this.quantityDecrement(
                                                    item,
                                                    item["quantity"],
                                                    item["id"]
                                                  );
                                                }}
                                              >
                                                -
                                              </Button>
                                            )}
                                            <span className="count">
                                              {item["quantity"]}
                                            </span>
                                            <Button
                                              className="quantitybtn"
                                              onClick={() => {
                                                this.quantityIncrement(
                                                  item,
                                                  item["measurementType"],
                                                  item["quantity"],
                                                  item["id"]
                                                );
                                              }}
                                            >
                                              +
                                            </Button>

                                            <Select
                                              className="cartquantitydropdown"
                                              notFoundContent={"Not found?!"}
                                              defaultValue={
                                                item["measurementType"]
                                              }
                                              onChange={(value) => {
                                                this.changeMeasurementType(
                                                  value,
                                                  item["id"],
                                                  item["quantity"]
                                                );
                                              }}
                                              style={{
                                                width: "110px",
                                                fontSize: "16px",
                                              }}
                                            >
                                              {/* <Option value='ton'>Ton</Option> */}
                                              {item["itemType"] !== "bulk" && (
                                                <Option value="Pallet">
                                                  Pallet
                                                </Option>
                                              )}
                                              {/* <Option value='yard'>Yard</Option> */}
                                              <Option value="Truckload">
                                                Truckload
                                              </Option>
                                            </Select>
                                          </div>
                                        </Col>
                                        <Col
                                          lg={5}
                                          md={5}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <Select
                                            className="cartquantitydropdown"
                                            notFoundContent={"Not found?!"}
                                            defaultValue={item["deliveryTruck"]}
                                            placeholder="Select Delivery Truck..."
                                            mode="multiple"
                                            // onChange={(value) => this.setState({ deliveryTruck: value })}
                                            onChange={(value) => {
                                              this.changeTruckType(
                                                value,
                                                item["id"]
                                              );
                                            }}
                                            disabled={
                                              item.measurementType === "Pallet"
                                            }
                                            style={{ width: "90%" }}
                                          >
                                            <Option value="Tractor Trailer">
                                              Tractor Trailer
                                            </Option>
                                            <Option value="Dump Truck/Triaxle">
                                              Dump Truck/Triaxle
                                            </Option>
                                            <Option value="Mason Dump">
                                              Mason Dump
                                            </Option>
                                            <Option value="Flatbed with forklift">
                                              Flatbed with forklift
                                            </Option>
                                            <Option value="Flatbed">
                                              Flatbed
                                            </Option>
                                            <Option value="Customer Pickup">
                                              Customer Pickup
                                            </Option>
                                          </Select>
                                        </Col>
                                        <Col
                                          lg={2}
                                          md={2}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <span
                                            className="cartitemtext"
                                            style={{
                                              fontSize: "17px",
                                              float: "right",
                                            }}
                                          >
                                            {"$" +
                                              (item["totalAmt"] !== null
                                                ? item["totalAmt"]
                                                : "0")}
                                          </span>
                                        </Col>
                                        <Col
                                          lg={2}
                                          md={2}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <img
                                            src={Trash}
                                            alt="img"
                                            onClick={() => {
                                              if (
                                                window.confirm(
                                                  "Are you sure you want to delete this item?"
                                                )
                                              )
                                                this.deleteCartItem(item["id"]);
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "50px",
                                            }}
                                          />
                                        </Col>
                                      </div>
                                    </Row>
                                  </div>
                                }
                                key="1"
                              >
                                {index === 0 && (
                                  <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                      <Row gutter={10}>
                                        <Col lg={10} md={10} sm={24} xs={24}>
                                          <Form.Item
                                            className="Formitem"
                                            label={
                                              <span className="label">
                                                PO #
                                              </span>
                                            }
                                            required={false}
                                          >
                                            {getFieldDecorator(
                                              item["id"] + "_poNumber",
                                              {
                                                rules: [
                                                  {
                                                    required: false,
                                                    message:
                                                      "Please input your po number",
                                                  },
                                                ],
                                              }
                                            )(
                                              <Input
                                                onChange={(e) =>
                                                  this.changeFieldValue(
                                                    e.target.value,
                                                    index,
                                                    "_poNumber"
                                                  )
                                                }
                                              />
                                            )}
                                          </Form.Item>
                                        </Col>
                                        <Col lg={14} md={14} sm={24} xs={24}>
                                          <Form.Item
                                            className="Formitem"
                                            label={
                                              <span className="label">
                                                Location
                                              </span>
                                            }
                                          >
                                            {getFieldDecorator(
                                              item["id"] + "_location",
                                              {
                                                rules: [
                                                  {
                                                    required:
                                                      item.measurementType !==
                                                      "Pallet",
                                                    message:
                                                      "Please select your location",
                                                  },
                                                ],
                                              }
                                            )(
                                              <Select
                                                placeholder={
                                                  "Selection location"
                                                }
                                                onChange={(e) =>
                                                  this.changeFieldValue(
                                                    e,
                                                    index,
                                                    "_location"
                                                  )
                                                }
                                                disabled={
                                                  item.measurementType ===
                                                  "Pallet"
                                                }
                                              >
                                                {this.state.locations.map(
                                                  (location, index) => (
                                                    <Option
                                                      key={"location" + index}
                                                      value={location}
                                                    >
                                                      {location}
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                            )}
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                      <Row gutter={10}>
                                        <Col lg={6} md={6} sm={24} xs={24}>
                                          <Form.Item
                                            className="Formitem"
                                            label={
                                              <span className="label">
                                                Requested Date
                                              </span>
                                            }
                                          >
                                            {getFieldDecorator(
                                              item["id"] + "_deliveryDate",
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message:
                                                      "Please input requested delivery date",
                                                  },
                                                ],
                                              }
                                            )(
                                              <DatePicker
                                                format="MM-DD-YYYY"
                                                onChange={(e) =>
                                                  this.changeFieldValue(
                                                    e,
                                                    index,
                                                    "_deliveryDate"
                                                  )
                                                }
                                                // onChange={this.datefield}
                                                disabledDate={(current) => {
                                                  return (
                                                    current &&
                                                    current.valueOf() <
                                                      Date.now()
                                                  );
                                                }}
                                              />
                                            )}
                                          </Form.Item>
                                        </Col>
                                        <Col lg={6} md={6} sm={24} xs={24}>
                                          <Form.Item
                                            className="Formitem"
                                            label={
                                              <span className="label">
                                                Preferred Delivery Hours
                                              </span>
                                            }
                                            required={false}
                                          >
                                            <Row gutter={10}>
                                              <Col
                                                lg={12}
                                                md={12}
                                                sm={24}
                                                xs={24}
                                              >
                                                <Form.Item>
                                                  {getFieldDecorator(
                                                    item["id"] +
                                                      "_deliveryStartTime",
                                                    {
                                                      rules: [
                                                        {
                                                          required: false,
                                                          message:
                                                            "Please input requested delivery start time",
                                                        },
                                                      ],
                                                    }
                                                  )(
                                                    <TimePicker
                                                      placeholder="Start Time"
                                                      format={format}
                                                      // open={this.state.startOpen}
                                                      defaultOpenValue={moment(
                                                        "00:00",
                                                        "hh:mm A"
                                                      )}
                                                      use12Hours={true}
                                                      onOpenChange={(
                                                        startOpen
                                                      ) =>
                                                        this.setState({
                                                          startOpen,
                                                        })
                                                      }
                                                      onChange={(value) =>
                                                        this.setStartValue(
                                                          value,
                                                          index,
                                                          "_deliveryStartTime"
                                                        )
                                                      }
                                                      minuteStep={15}
                                                      // disabledHours={this.getStartDisabledHours}
                                                      // disabledMinutes={this.getStartDisabledMinutes}
                                                      // addon={() => (
                                                      //   <Button size="small" type="primary" onClick={() => this.setState({ startOpen: false })}>
                                                      //     Ok
                                                      //   </Button>
                                                      // )}
                                                    />
                                                  )}
                                                </Form.Item>
                                              </Col>
                                              <Col
                                                lg={12}
                                                md={12}
                                                sm={24}
                                                xs={24}
                                              >
                                                <Form.Item>
                                                  {getFieldDecorator(
                                                    item["id"] +
                                                      "_deliveryEndTime",
                                                    {
                                                      rules: [
                                                        {
                                                          required: false,
                                                          message:
                                                            "Please input requested delivery end time",
                                                        },
                                                      ],
                                                    }
                                                  )(
                                                    <TimePicker
                                                      placeholder="End Time"
                                                      format={format}
                                                      use12Hours={true}
                                                      minuteStep={15}
                                                      defaultOpenValue={moment(
                                                        "00:00",
                                                        "hh:mm A"
                                                      )}
                                                      // onOpenChange={() => this.setState({ endOpen: true })}
                                                      // onSelect={(value) => this.setEndValue(value,index,'_deliveryEndTime')}
                                                      onOpenChange={(value) =>
                                                        this.setEndValue(
                                                          value,
                                                          index,
                                                          "_deliveryEndTime",
                                                          item["id"]
                                                        )
                                                      }
                                                      // disabledHours={this.getEndDisabledHours}
                                                      // disabledMinutes={this.getEndDisabledMinutes}
                                                      // addon={() => (
                                                      //   <Button size="small" type="primary" onClick={() => this.setState({ endOpen: false })}>
                                                      //     Ok
                                                      //   </Button>
                                                      // )}
                                                    />
                                                  )}
                                                </Form.Item>
                                              </Col>
                                            </Row>
                                          </Form.Item>
                                        </Col>
                                        <Col lg={10} md={10} sm={24} xs={24}>
                                          <p
                                            style={{
                                              marginTop: "7%",
                                              marginLeft: "4%",
                                            }}
                                          >
                                            <b>Note:</b> We cannot guarantee the
                                            delivery date will be the date
                                            requested. However the date chosen
                                            will help educate us on the urgency
                                            of your order.
                                          </p>
                                        </Col>
                                      </Row>
                                      <Row gutter={10}>
                                        <Col lg={14} md={14} sm={24} xs={24}>
                                          <Form.Item
                                            className="Formitem"
                                            label={
                                              <span className="label">
                                                Notes
                                              </span>
                                            }
                                          >
                                            {getFieldDecorator(
                                              item["id"] + "_notes",
                                              {
                                                rules: [
                                                  {
                                                    required: false,
                                                    message:
                                                      "Please input your Notes",
                                                  },
                                                ],
                                              }
                                            )(
                                              <TextArea
                                                size="large"
                                                onChange={(e) =>
                                                  this.changeFieldValue(
                                                    e.target.value,
                                                    index,
                                                    "_notes"
                                                  )
                                                }
                                              />
                                            )}
                                          </Form.Item>
                                        </Col>
                                        <Col lg={10} md={10} sm={24} xs={24}>
                                          <Form.Item
                                            label={
                                              <span className="text-modal">
                                                Order Document
                                              </span>
                                            }
                                            className="form-item-mobile"
                                          >
                                            <Upload
                                              name="avatar"
                                              listType="picture-card"
                                              className="avatar-uploader"
                                              style={{
                                                borderRadius: "50%",
                                                width: "100%",
                                                height: "100%",
                                              }}
                                              showUploadList={false}
                                              beforeUpload={beforeUpload}
                                              onChange={(e) =>
                                                this.handleUploadPic(
                                                  e,
                                                  "_order_document_",
                                                  item["id"] +
                                                    `_poNumber_${index + 1}`,
                                                  index + 1
                                                )
                                              }
                                            >
                                              {this.state.imageUrl[index] ? (
                                                <img
                                                  src={
                                                    this.state.imageUrl[
                                                      index
                                                    ] &&
                                                    this.state.imageUrl[
                                                      index
                                                    ].includes(".pdf")
                                                      ? Docsample
                                                      : `https://${
                                                          process.env
                                                            .REACT_APP_S3_BUCKET
                                                        }.s3.amazonaws.com/public/${encodeURIComponent(
                                                          this.state.imageUrl[
                                                            index
                                                          ]
                                                        )}`
                                                  }
                                                  alt="avatar"
                                                  style={{
                                                    width: "100px",
                                                    height: "100%",
                                                  }}
                                                />
                                              ) : (
                                                <CameraOutlined className="camera-icon" />
                                              )}
                                            </Upload>
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}
                              </Panel>
                            </Collapse>
                          );
                        } else {
                          return (
                            <Collapse
                              key={item["id"]}
                              defaultActiveKey={["1"]}
                              expandIconPosition={this.state.expandIconPosition}
                              expandIcon={({ isActive }) => (
                                <Icon
                                  type="caret-down"
                                  rotate={isActive ? 180 : 0}
                                />
                              )}
                              onChange={this.callback}
                              className="custom_collapse"
                              style={{ marginTop: "2%", borderRadius: "10px" }}
                            >
                              <Panel
                                header={
                                  <div>
                                    <Row gutter={8}>
                                      <Col
                                        lg={1}
                                        md={1}
                                        sm={24}
                                        xs={24}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <Checkbox.Group
                                          defaultValue={["order"]}
                                          style={{ width: "100%" }}
                                          onChange={this.onChange}
                                        >
                                          <Checkbox
                                            value="order"
                                            className="custom_checkbox"
                                          />
                                        </Checkbox.Group>
                                      </Col>
                                      <div
                                        onClick={(event) =>
                                          event.stopPropagation()
                                        }
                                      >
                                        <Col
                                          lg={1}
                                          md={1}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <p>1</p>
                                        </Col>
                                        <Col lg={7} md={7} sm={24} xs={24}>
                                          <img
                                            style={{
                                              width: "70px",
                                              height: "60px",
                                              borderRadius: "5px",
                                            }}
                                            src={item["image"]}
                                            alt="img"
                                          />
                                          <span style={{ marginLeft: "10px" }}>
                                            <b>
                                              {item["productName"] +
                                                " - " +
                                                item["size"]}
                                            </b>
                                          </span>
                                        </Col>
                                        <Col
                                          lg={6}
                                          md={6}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          {/* <span className="count" style={{ textDecoration: 'underline' }}>{item["quantity"]}</span> */}
                                          <div>
                                            {item["quantity"] <= 1 ? (
                                              <Button
                                                disabled
                                                className="quantitybtn"
                                                onClick={() => {
                                                  this.quantityDecrement(
                                                    item,
                                                    item["quantity"],
                                                    item["id"]
                                                  );
                                                }}
                                              >
                                                -
                                              </Button>
                                            ) : (
                                              <Button
                                                className="quantitybtn"
                                                onClick={() => {
                                                  this.quantityDecrement(
                                                    item,
                                                    item["quantity"],
                                                    item["id"]
                                                  );
                                                }}
                                              >
                                                -
                                              </Button>
                                            )}
                                            <span className="count">
                                              {item["quantity"]}
                                            </span>
                                            <Button
                                              className="quantitybtn"
                                              onClick={() => {
                                                this.quantityIncrement(
                                                  item,
                                                  item["measurementType"],
                                                  item["quantity"],
                                                  item["id"]
                                                );
                                              }}
                                            >
                                              +
                                            </Button>

                                            <Select
                                              className="cartquantitydropdown"
                                              notFoundContent={"Not found?!"}
                                              defaultValue={
                                                item["measurementType"]
                                              }
                                              disabled={
                                                item["itemType"] !== "bulk"
                                              }
                                              onChange={(value) => {
                                                this.changeMeasurementType(
                                                  value,
                                                  item["id"],
                                                  item["quantity"]
                                                );
                                              }}
                                              style={{
                                                width: "110px",
                                                fontSize: "16px",
                                              }}
                                            >
                                              {/* <Option value='ton'>Ton</Option> */}
                                              {item["itemType"] !== "bulk" && (
                                                <Option value="Pallet">
                                                  Pallet
                                                </Option>
                                              )}
                                              {/* <Option value='yard'>Yard</Option> */}
                                              <Option value="Truckload">
                                                Truckload
                                              </Option>
                                            </Select>
                                          </div>
                                        </Col>
                                        <Col
                                          lg={5}
                                          md={5}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <Select
                                            className="cartquantitydropdown"
                                            notFoundContent={"Not found?!"}
                                            defaultValue={item["deliveryTruck"]}
                                            placeholder="Select Delivery Truck..."
                                            mode="multiple"
                                            // onChange={(value) => this.setState({ deliveryTruck: value })}
                                            onChange={(value) => {
                                              this.changeTruckType(
                                                value,
                                                item["id"]
                                              );
                                            }}
                                            disabled={
                                              item.measurementType === "Pallet"
                                            }
                                            style={{ width: "90%" }}
                                          >
                                            <Option value="Tractor Trailer">
                                              Tractor Trailer
                                            </Option>
                                            <Option value="Dump Truck/Triaxle">
                                              Dump Truck/Triaxle
                                            </Option>
                                            <Option value="Mason Dump">
                                              Mason Dump
                                            </Option>
                                            <Option value="Flatbed with forklift">
                                              Flatbed with forklift
                                            </Option>
                                            <Option value="Flatbed">
                                              Flatbed
                                            </Option>
                                            <Option value="Customer Pickup">
                                              Customer Pickup
                                            </Option>
                                          </Select>
                                        </Col>
                                        <Col
                                          lg={2}
                                          md={2}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <span
                                            className="cartitemtext"
                                            style={{
                                              fontSize: "17px",
                                              float: "right",
                                            }}
                                          >
                                            {"$" +
                                              (item["totalAmt"] !== null
                                                ? item["totalAmt"]
                                                : "0")}
                                          </span>
                                        </Col>
                                        <Col
                                          lg={2}
                                          md={2}
                                          sm={24}
                                          xs={24}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <img
                                            src={Trash}
                                            alt="img"
                                            onClick={() => {
                                              if (
                                                window.confirm(
                                                  "Are you sure you want to delete this item?"
                                                )
                                              )
                                                this.deleteCartItem(item["id"]);
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "50px",
                                            }}
                                          />
                                        </Col>
                                      </div>
                                    </Row>
                                  </div>
                                }
                                key="1"
                              >
                                <Row>
                                  <Col lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={10}>
                                      <Col lg={10} md={10} sm={24} xs={24}>
                                        <Form.Item
                                          className="Formitem"
                                          label={
                                            <span className="label">PO #</span>
                                          }
                                          required={false}
                                        >
                                          {getFieldDecorator(
                                            item["id"] + "_poNumber",
                                            {
                                              rules: [
                                                {
                                                  required: false,
                                                  message:
                                                    "Please input your po number",
                                                },
                                              ],
                                            }
                                          )(
                                            <Input
                                              onChange={(e) =>
                                                this.changeFieldValue(
                                                  e.target.value,
                                                  index,
                                                  "_poNumber"
                                                )
                                              }
                                            />
                                          )}
                                        </Form.Item>
                                      </Col>
                                      <Col lg={14} md={14} sm={24} xs={24}>
                                        <Form.Item
                                          className="Formitem"
                                          label={
                                            <span className="label">
                                              Location
                                            </span>
                                          }
                                        >
                                          {getFieldDecorator(
                                            item["id"] + "_location",
                                            {
                                              rules: [
                                                {
                                                  required:
                                                    item.measurementType !==
                                                    "Pallet",
                                                  message:
                                                    "Please select your location",
                                                },
                                              ],
                                            }
                                          )(
                                            <Select
                                              placeholder={"Selection location"}
                                              onChange={(e) =>
                                                this.changeFieldValue(
                                                  e,
                                                  index,
                                                  "_location"
                                                )
                                              }
                                              disabled={
                                                item.measurementType ===
                                                "Pallet"
                                              }
                                            >
                                              {this.state.locations.map(
                                                (location, index) => (
                                                  <Option
                                                    key={"location" + index}
                                                    value={location}
                                                  >
                                                    {location}
                                                  </Option>
                                                )
                                              )}
                                            </Select>
                                          )}
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                    <Row gutter={10}>
                                      <Col lg={6} md={6} sm={24} xs={24}>
                                        <Form.Item
                                          className="Formitem"
                                          label={
                                            <span className="label">
                                              Requested Date
                                            </span>
                                          }
                                        >
                                          {getFieldDecorator(
                                            item["id"] + "_deliveryDate",
                                            {
                                              rules: [
                                                {
                                                  required: true,
                                                  message:
                                                    "Please input requested delivery date",
                                                },
                                              ],
                                            }
                                          )(
                                            <DatePicker
                                              format="MM-DD-YYYY"
                                              onChange={(e) =>
                                                this.changeFieldValue(
                                                  e,
                                                  index,
                                                  "_deliveryDate"
                                                )
                                              }
                                              // onChange={this.datefield}
                                              disabledDate={(current) => {
                                                return (
                                                  current &&
                                                  current.valueOf() < Date.now()
                                                );
                                              }}
                                            />
                                          )}
                                        </Form.Item>
                                      </Col>
                                      <Col lg={6} md={6} sm={24} xs={24}>
                                        <Form.Item
                                          className="Formitem"
                                          label={
                                            <span className="label">
                                              Preferred Delivery Hours
                                            </span>
                                          }
                                          required={false}
                                        >
                                          <Row gutter={10}>
                                            <Col
                                              lg={12}
                                              md={12}
                                              sm={24}
                                              xs={24}
                                            >
                                              <Form.Item>
                                                {getFieldDecorator(
                                                  item["id"] +
                                                    "_deliveryStartTime",
                                                  {
                                                    rules: [
                                                      {
                                                        required: false,
                                                        message:
                                                          "Please input requested delivery start time",
                                                      },
                                                    ],
                                                  }
                                                )(
                                                  <TimePicker
                                                    placeholder="Start Time"
                                                    format={format}
                                                    // open={this.state.startOpen}
                                                    defaultOpenValue={moment(
                                                      "00:00",
                                                      "hh:mm A"
                                                    )}
                                                    use12Hours={true}
                                                    onOpenChange={(startOpen) =>
                                                      this.setState({
                                                        startOpen,
                                                      })
                                                    }
                                                    onChange={(value) =>
                                                      this.setStartValue(
                                                        value,
                                                        index,
                                                        "_deliveryStartTime"
                                                      )
                                                    }
                                                    minuteStep={15}
                                                    // disabledHours={this.getStartDisabledHours}
                                                    // disabledMinutes={this.getStartDisabledMinutes}
                                                    // addon={() => (
                                                    //   <Button size="small" type="primary" onClick={() => this.setState({ startOpen: false })}>
                                                    //     Ok
                                                    //   </Button>
                                                    // )}
                                                  />
                                                )}
                                              </Form.Item>
                                            </Col>
                                            <Col
                                              lg={12}
                                              md={12}
                                              sm={24}
                                              xs={24}
                                            >
                                              <Form.Item>
                                                {getFieldDecorator(
                                                  item["id"] +
                                                    "_deliveryEndTime",
                                                  {
                                                    rules: [
                                                      {
                                                        required: false,
                                                        message:
                                                          "Please input requested delivery end time",
                                                      },
                                                    ],
                                                  }
                                                )(
                                                  <TimePicker
                                                    placeholder="End Time"
                                                    format={format}
                                                    use12Hours={true}
                                                    minuteStep={15}
                                                    defaultOpenValue={moment(
                                                      "00:00",
                                                      "hh:mm A"
                                                    )}
                                                    // onOpenChange={() => this.setState({ endOpen: true })}
                                                    // onSelect={(value) => this.setEndValue(value,index,'_deliveryEndTime')}
                                                    onOpenChange={(value) =>
                                                      this.setEndValue(
                                                        value,
                                                        index,
                                                        "_deliveryEndTime",
                                                        item["id"]
                                                      )
                                                    }
                                                    // disabledHours={this.getEndDisabledHours}
                                                    // disabledMinutes={this.getEndDisabledMinutes}
                                                    // addon={() => (
                                                    //   <Button size="small" type="primary" onClick={() => this.setState({ endOpen: false })}>
                                                    //     Ok
                                                    //   </Button>
                                                    // )}
                                                  />
                                                )}
                                              </Form.Item>
                                            </Col>
                                          </Row>
                                        </Form.Item>
                                      </Col>
                                      <Col lg={10} md={10} sm={24} xs={24}>
                                        <p
                                          style={{
                                            marginTop: "7%",
                                            marginLeft: "4%",
                                          }}
                                        >
                                          <b>Note:</b> We cannot guarantee the
                                          delivery date will be the date
                                          requested. However the date chosen
                                          will help educate us on the urgency of
                                          your order.
                                        </p>
                                      </Col>
                                    </Row>
                                    <Row gutter={10}>
                                      <Col lg={14} md={14} sm={24} xs={24}>
                                        <Form.Item
                                          className="Formitem"
                                          label={
                                            <span className="label">Notes</span>
                                          }
                                        >
                                          {getFieldDecorator(
                                            item["id"] + "_notes",
                                            {
                                              rules: [
                                                {
                                                  required: false,
                                                  message:
                                                    "Please input your Notes",
                                                },
                                              ],
                                            }
                                          )(
                                            <TextArea
                                              size="large"
                                              onChange={(e) =>
                                                this.changeFieldValue(
                                                  e.target.value,
                                                  index,
                                                  "_notes"
                                                )
                                              }
                                            />
                                          )}
                                        </Form.Item>
                                      </Col>
                                      <Col lg={10} md={10} sm={24} xs={24}>
                                        <Form.Item
                                          label={
                                            <span className="text-modal">
                                              Order Document
                                            </span>
                                          }
                                          className="form-item-mobile"
                                        >
                                          <Upload
                                            name="avatar"
                                            listType="picture-card"
                                            className="avatar-uploader"
                                            style={{
                                              borderRadius: "50%",
                                              width: "100%",
                                              height: "100%",
                                            }}
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={(e) =>
                                              this.handleUploadPic(
                                                e,
                                                "_order_document_",
                                                item["id"] +
                                                  `_poNumber_${index + 1}`,
                                                index + 1
                                              )
                                            }
                                          >
                                            {this.state.imageUrl[index] ? (
                                              <img
                                                src={
                                                  this.state.imageUrl[index] &&
                                                  this.state.imageUrl[
                                                    index
                                                  ].includes(".pdf")
                                                    ? Docsample
                                                    : `https://${
                                                        process.env
                                                          .REACT_APP_S3_BUCKET
                                                      }.s3.amazonaws.com/public/${encodeURIComponent(
                                                        this.state.imageUrl[
                                                          index
                                                        ]
                                                      )}`
                                                }
                                                alt="avatar"
                                                style={{
                                                  width: "100px",
                                                  height: "100%",
                                                }}
                                              />
                                            ) : (
                                              <CameraOutlined className="camera-icon" />
                                            )}
                                          </Upload>
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Panel>
                            </Collapse>
                          );
                        }
                      })}
                    </div>
                  </Col>
                </Col>

                <Col lg={7} md={7} sm={24} xs={24}>
                  <div className="site-card-border-less-wrapper">
                    <Card style={{ minHeight: "88vh" }}>
                      <div style={{ marginTop: "10vh" }}>
                        <h3 className="cartheading">Summary</h3>
                        <Row>
                          <Col lg={18} md={18} sm={24} xs={24}>
                            <h3 className="subtotal">Subtotal</h3>
                          </Col>
                          <Col lg={6} md={6} sm={24} xs={24}>
                            <h3 className="subtotal" style={{ float: "right" }}>
                              <NumberFormat
                                value={parseFloat(subtotal).toFixed(2)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                            </h3>
                            {/* <h3 className="subtotal" style={{ float: "right" }}>{"$" + parseFloat(subtotal).toFixed(2)}</h3> */}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={18} md={18} sm={24} xs={24}>
                            <h3 className="subtotal">Delivery</h3>
                          </Col>
                          <Col lg={6} md={6} sm={24} xs={24}>
                            <h3 className="subtotal" style={{ float: "right" }}>
                              <NumberFormat
                                value={parseFloat(this.state.delivery).toFixed(
                                  2
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                            </h3>
                            {/* <h3 className="subtotal" style={{ float: "right" }}>{"$" + parseFloat(this.state.delivery).toFixed(2)}</h3> */}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={18} md={18} sm={24} xs={24}>
                            <h3 className="subtotal" style={{ color: "black" }}>
                              Total
                            </h3>
                          </Col>
                          <Col lg={6} md={6} sm={24} xs={24}>
                            <h3
                              className="subtotal"
                              style={{ color: "black", float: "right" }}
                            >
                              <NumberFormat
                                value={parseFloat(
                                  subtotal + this.state.delivery
                                ).toFixed(2)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                              {/* {"$" + parseFloat(subtotal + this.state.delivery).toFixed(2)} */}
                            </h3>
                          </Col>
                        </Row>
                      </div>
                      <Checkbox
                        className="custom_checkbox"
                        onChange={this.handleConfirmDelivery}
                      >
                        I confirm the following delivery options for my order are correct:
                      </Checkbox>
                      <div>
                        {cartData.map((item, index) => (
                          <div key={item.id} className="cartItemCheck">
                            <p>Item #{index + 1} delivery type: 
                              {Array.isArray(item.deliveryTruck)
                                ? item.deliveryTruck.map((option, optionIndex) => (
                                    <p key={optionIndex}>{option}</p>
                                  ))
                                : <p>{item.deliveryTruck}</p>
                              }
                            </p>
                          </div>
                        ))}
                      </div>

                      <Form.Item
                        style={{ marginBottom: "30px", textAlign: "center" }}
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="confirmorder"
                          disabled={!this.state.confirmDeliveryOption}
                        >
                          Complete Order
                        </Button>
                      </Form.Item>
                    </Card>
                  </div>
                  {/* </div> */}
                </Col>
              </Form>
            </Row>
          </Spin>
        </Spin>
      </div>
    );
  }
}

export default Form.create({ name: "Finishorder" })(
  withAppContext(withRouter(Finishorder))
);
